import React from "react";
import "./AddBreak.css";

const Break = (props) => {
  const { AddTen } = props;
  return (
    <div>
      <h6>Add A Break</h6>
      <div className="break p-3 mb-5">
        <span onClick={() => AddTen(10)}>10s</span>
        <span onClick={() => AddTen(20)}>20s</span>
        <span onClick={() => AddTen(30)}>30s</span>
        <span onClick={() => AddTen(40)}>40s</span>
        <span onClick={() => AddTen(50)}>50s</span>
      </div>
    </div>
  );
};

export default Break;
